interface BrandWordmarkProps {
  alphaColor?: string;
  alphaFontSizeEm?: number;
  alphaLetterSpacing?: string;
}

export function BrandWordmark({
  alphaColor = "#e8590c",
  alphaFontSizeEm = 0.42,
  alphaLetterSpacing = "0.1em",
}: BrandWordmarkProps) {
  return (
    <span>
      CLUB DROBBIT{" "}
      <span
        style={{
          verticalAlign: "super",
          fontSize: `${alphaFontSizeEm}em`,
          letterSpacing: alphaLetterSpacing,
          fontWeight: 700,
          color: alphaColor,
        }}
      >
        ALPHA
      </span>
    </span>
  );
}
